<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <a
          href="javascript:void(0)"
          class="rs-btn rs-btn-third rs-btn-third-icon-left"
          (click)="routeToStep1()"
          ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i>
          {{ 'flexEmergency.common.back' | translate }}
        </a>

        <div class="rs-me"></div>
        <h1 class="rs-tit4">{{ 'flexEmergency.activation.title' | translate }}</h1>
        <p [innerHTML]="'flexEmergency.activation.infoSection' | translate"></p>
        <div class="rs-flex-row">
          <div class="rs-flex-columns small-12 medium-5 rs-order-m2">
            <img
              alt=""
              src="{{ 'flexEmergency.activation.imageLink' | translate }}"
              data-src="{{ 'flexEmergency.activation.imageLink' | translate }}"
            />
          </div>
          <div class="rs-flex-columns small-12 medium-7 rs-order-m1">
            <p [innerHTML]="'flexEmergency.activation.faqContent' | translate"></p>
            <mprd-order-button
              [(option)]="selectedOption"
              [(orderDisabled)]="orderButtonsDisabled"
              [selectedProduct]="selectedProduct"
              (resultEmit)="onResult($event)"
              data-tms-event="button-click"
              data-tms-button-zone="flex-emergency-activation"
              data-tms-button-name="confirm activation"
            ></mprd-order-button>
          </div>
        </div>
      </div>
      <px-alert [alertKey]="'flexEmergencyAlert'"></px-alert>
    </div>
    <div class="rs-le2"></div>
  </main>
</section>
